// extracted by mini-css-extract-plugin
module.exports = {"buttonCheckBox":"styles_buttonCheckBox__34j3-","searchSize":"styles_searchSize__2Zx7L","checkboxButton":"styles_checkboxButton__1X6-5"};